import { techprojectDevelopersAPI } from "@/views/handbook/techprojectDevelopers/api";
import { handbookContractorsAPI } from "@/views/handbook/contractors/api";

export const getTechprojectDevelopers = async () => {
  try {
    const res = await techprojectDevelopersAPI.getList();
    return res?.data;
  } catch (e) {
  }
};
export const addHandbookTechprojectDeveloper = async (body = {}) => {
  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    formData.append(key, value);
  });
  try {
    const res = await techprojectDevelopersAPI.addTechprojectDeveloper(
      formData
    );
    return res?.data;
  } catch (e) {}
};

export const updateHandbookTechprojectDeveloper = async (
  techproject_developer_id,
  body = {}
) => {
  try {
    const res = await techprojectDevelopersAPI.updateTechprojectDeveloper(
      techproject_developer_id,
      body
    );
    return res?.data;
  } catch (e) {}
};
export const deleteHandbookTechprojectDeveloper = async (
  techproject_developer_id
) => {
  try {
    const res = await techprojectDevelopersAPI.deleteTechprojectDeveloper(
      techproject_developer_id
    );
    return res?.data;
  } catch (e) {}
};
export const getCity = async () => {
  try {
    const res = await handbookContractorsAPI.getCity();
    return res?.data;
  } catch (e) {}
};
export const getContragentType = async () => {
  try {
    const res = await handbookContractorsAPI.getContragentType();
    return res?.data;
  } catch (e) {}
};

export const sendTo1C = async (techproject_developer_id, is_send_to_1c) => {
  try {
    const response = await techprojectDevelopersAPI.sendTo1C(
      techproject_developer_id,
      is_send_to_1c,
    );
    return response?.data;
  } catch (error) {}
};

export const techprojectDevelopersColumns = [
  {
    name: "techproject_developer_id",
    field: "ID",
    label: "ID",
    align: "center",
  },
  {
    name: "contractor",
    field: "contractor_name",
    label: "Контрагент",
    align: "left",
  },
  { name: "roles", field: "roles", label: "Роли", align: "left" },
  { name: "actions", field: "actions", label: "", align: "center" },
];
